import {
  CommunityPostListDocument,
  CreatePostDocument,
  CreatePostMutation,
  CreatePostMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreatePost = () => {
  const [executeMutation, { loading }] = useMutation(CreatePostDocument, {
    extractorFn: (data: CreatePostMutation) => data.postsMutations.createPostsPost,
  })

  const createPost = async (variables: CreatePostMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [CommunityPostListDocument],
      awaitRefetchQueries: true,
    })
  }

  return {
    createPost,
    loadingCreatePost: loading,
  }
}
